import { Box } from '@mui/system';
import { FC } from 'react';
import { useEventBus } from '../../../../../../hooks/use-event-bus';
import { EventPatientProfile } from '../../../../../../types/event-bus';
import { WidgetRoutePath } from '../../../../../layout/slideout/patient-profile-widget/navigation/route-config';
import { usePatientIvStatusDialog } from '../../../hooks/use-patient-iv-status-dialog/hook';
import { WarningMessage } from '../../styles';

export const AppointmentEndedMessage: FC = () => {
  const { appointment, patientFlow, locationId, onClose } = usePatientIvStatusDialog();
  const { publish } = useEventBus();

  if (!appointment?.isEnded || !patientFlow) return null;

  const handleHereClick = () => {
    onClose();
    publish({
      messageType: 'patientProfile',
      data: {
        patientId: patientFlow.patientId,
        locationId,
        route: WidgetRoutePath.BILLING
      } as EventPatientProfile['data']
    });
  };

  return (
    <WarningMessage>
      This appointment is in the past so we cannot run an insurance verification for this appointment. If you would like
      to verify this patients insurance you can do it through the patient profile{' '}
      <Box onClick={handleHereClick} sx={{ textDecoration: 'underline', cursor: 'pointer', display: 'inline' }}>
        here
      </Box>
      .
    </WarningMessage>
  );
};
